import Select from 'react-select';
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { Grid, TextField, FormControl, Avatar } from "@mui/material";
import logo_icon from '../../../assets/images/Logo/Bharat-Darshan-Logo.png';
import { RedirectPageData } from "../../../utils/static-data/index.js";
import { api_urls } from "../../../utils/api-urls/index.js";
import * as BannerActions from '../../../redux/actions/bannerAction.js';

const AddBanner = ({ mode }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const stateData = location?.state?.stateData;

    const redirectPageOptions = [{ value: 'all', label: 'Select All' }, ...RedirectPageData.map(item => ({ value: item, label: item }))]; //! Redirect-Page Option
    const [inputFieldDetail, setInputFieldDetail] = useState({ bannerName: stateData ? stateData?.banner : '', status: stateData ? stateData?.status : '' });
    const [redirectPage, setRedirectPage] = useState(stateData ? stateData?.redirect_to : []);
    const [bannerImage, setBannerImage] = useState({ file: stateData ? api_urls + stateData?.image : logo_icon, bytes: "" });
    const [priorityBanner, setPriorityBanner] = useState(stateData ? stateData?.priority : false);
    const [inputFieldError, setInputFieldError] = useState({ bannerName: '', redirectPage: '', bannerImage: '', status: '' });

    //* Handle Input Field : Error
    const handleInputFieldError = (input, value) => {
        setInputFieldError((prev) => ({ ...prev, [input]: value }))
    }

    //* Handle Input Field : Data
    const handleInputField = (e) => {
        const { name, value } = e.target;
        setInputFieldDetail({ ...inputFieldDetail, [name]: value });
    };

    //* Handle Redirect Page Option 
    const handleChangeRedirectPageOption = (selectedItems) => {
        if (selectedItems.some(item => item.value === 'all')) {
            setRedirectPage(RedirectPageData.map(item => item));
        } else {
            const selectedIds = selectedItems.map(item => item.value !== 'all' ? item.value : null).filter(Boolean);
            setRedirectPage(selectedIds);
        }
    };

    //* Handle banner Image
    const handleBannerImage = (e) => {
        if (e.target.files && e.target.files.length > 0) {
            if (e.target.files[0]?.size < 1 * 1024 * 1024) {
                setBannerImage({
                    file: URL.createObjectURL(e.target.files[0]),
                    bytes: e.target.files[0],
                });
            } else {
                alert("Please upload banner having size less than 1 MB")
            }
        }

        handleInputFieldError("bannerImage", null)
    };

    //! Handle Validation
    const handleValidation = () => {
        let isValid = true;
        const { bannerName, status } = inputFieldDetail;
        const { file } = bannerImage;

        if (redirectPage <= 0) {
            handleInputFieldError("redirectPage", "Please Select Redirect Page")
            isValid = false;
        }
        if (!bannerName) {
            handleInputFieldError("bannerName", "Please Enter Category Name")
            isValid = false;
        }
        if (!file) {
            handleInputFieldError("bannerImage", "Please Select Image")
            isValid = false;
        }
        return isValid;
    };

    //! Handle Submit - Creating banner
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (handleValidation()) {
            console.log("Banner Data :: ", { ...inputFieldDetail, bannerImage, redirectPage, priorityBanner })
            const { bannerName } = inputFieldDetail;
            redirectPage.map((value, index) => (console.log(`redirect_to[${index}]`, value)))

            if (stateData) {
                let formData = new FormData()
                formData.append("bannerId", stateData?._id)
                formData.append("banner", bannerName)
                redirectPage.map((value, index) => (formData.append(`redirect_to[${index}]`, value)))
                formData.append("image", bannerImage?.bytes);
                formData.append("priority", priorityBanner);

                const payload = {
                    data: formData,
                    onComplete: () => navigate("/banner")
                }

                //! Dispatching API for Updating Banner
                dispatch(BannerActions.updateBanner(payload));
            } else {
                let formData = new FormData();
                formData.append("banner", bannerName);
                redirectPage.map((value, index) => (formData.append(`redirect_to[${index}]`, value)))
                formData.append("image", bannerImage?.bytes);
                formData.append("priority", priorityBanner);

                const payload = {
                    data: formData,
                    onComplete: () => navigate("/banner")
                }

                //! Dispatching API for Creating Banner
                console.log("Payload ::: ", payload);
                dispatch(BannerActions.createBanner(payload));
            }
        }
    };

    return (
        <>
            <div style={{ padding: "20px", backgroundColor: "#fff", marginBottom: "20px", boxShadow: '0px 0px 5px lightgrey', borderRadius: "10px", color: "#000" }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "30px", fontFamily: 'Philosopher', backgroundColor: "#fff" }}>
                    <div style={{ fontSize: "20px", fontWeight: "600", color: "#667284" }}>{mode} Banner</div>
                    <div onClick={() => navigate("/banner")} style={{ fontWeight: "600", backgroundColor: "#164E62", color: "#fff", padding: "5px 10px", borderRadius: "5px", cursor: "pointer", fontSize: "14px" }}>Display</div>
                </div>

                <Grid container sx={{ alignItems: "center" }} spacing={3}>
                    <Grid item lg={6} md={6} sm={12} xs={12} >
                        <TextField
                            label="Banner Name" variant='outlined' fullWidth
                            name='bannerName'
                            value={inputFieldDetail?.bannerName}
                            onChange={handleInputField}
                            error={inputFieldError.bannerName ? true : false}
                            helperText={inputFieldError.bannerName}
                            onFocus={() => handleInputFieldError("bannerName", null)}
                        />
                    </Grid>

                    <Grid item lg={6} md={6} sm={12} xs={12} >
                        <FormControl fullWidth>
                            <Select
                                isMulti
                                options={redirectPageOptions}
                                value={redirectPageOptions.filter(option => redirectPage.includes(option.value))}
                                onChange={handleChangeRedirectPageOption}
                                styles={{ control: (base, state) => ({ ...base, minHeight: "52px" }) }}
                                onFocus={() => handleInputFieldError("redirectPage", null)}
                            />
                        </FormControl>
                        {inputFieldError?.redirectPage && <div style={{ color: "#D32F2F", fontSize: "10px", padding: "3px 15px 0 15px" }}>{inputFieldError?.redirectPage}</div>}
                    </Grid>

                    <Grid item lg={6} sm={6} md={12} xs={12} >
                        <Grid container sx={{ alignItems: "center", flexWrap: "nowrap" }}>
                            <Grid item xs={2} >
                                <Avatar src={bannerImage.file} style={{ width: 40, height: 40 }} />
                            </Grid>
                            <Grid component="label" item xs={10} style={{ backgroundColor: "#E2E8F0", textAlign: "center", color: "#666666", padding: "10px 30px", borderRadius: "20px", cursor: "pointer", fontWeight: "500", fontSize: "14px" }}>
                                Upload Banner Image
                                <input onChange={handleBannerImage} hidden accept="image/*" type="file" />
                            </Grid>
                        </Grid>
                        {inputFieldError?.bannerImage && <div style={{ color: "#D32F2F", fontSize: "10px", padding: "10px 0 0 15px" }}>{inputFieldError?.bannerImage}</div>}
                    </Grid>

                    <Grid item lg={6} md={6} xs={12} >
                        <div style={{ display: "flex", gap: "20px", border: "1px solid #C4C4C4", padding: "16px 13.5px", borderRadius: "5px" }}>
                            <label style={{ cursor: "pointer", color: "#666666", fontFamily: "Philosopher", fontSize: "13.5px", color: "#667284" }} htmlFor="layout-template">Priority</label>
                            <input defaultChecked={priorityBanner} onClick={(e) => setPriorityBanner(e.target.checked)} style={{ cursor: "pointer", marginTop: "0px", padding: "0px" }} id='layout-template' type="checkbox" />
                        </div>
                    </Grid>

                    <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Grid container sx={{ justifyContent: "space-between" }}>
                            <div onClick={handleSubmit} style={{ fontWeight: "500", backgroundColor: "#164E62", color: "#fff", padding: "10px 20px", borderRadius: "5px", cursor: "pointer", fontSize: "15px" }}>Submit</div>
                        </Grid>
                    </Grid>
                </Grid>
            </div>
        </>
    );
};

export default AddBanner;